// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Divider, DrawerBody, DrawerFooter, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Drawer } from "components"

// Config
import { API, Moment, Mask } from "config"

// Screens
import { Authenticate } from "screens"

export default function Edit({ data:consultant, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState()
    const [ errors, setErrors ]  = useState()
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'mobile': setForm({...form, [name]: Mask.mobile(value)}); break;
            case 'doc_cpf': setForm({...form, [name]: Mask.cpf(value)}); break;
            default: setForm({...form,  [name]: value}); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors({})

        try{
            await API.put(`/customers/${consultant?.customer.id}`, form)
            toast({ title: 'Dados do consultor atualizados.', status: 'info' })
            setForm({})
            setErrors({})
            onSuccess()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível atualizar', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
        <Drawer size="md" title={`Editar dados de ${consultant?.customer?.name}`} loading={loading} {...props}>
            <DrawerBody>

                <Form.Form onSubmit={auth.onOpen}>

                    <Alert>Lembrando aqui ao editar os dados de consultor, você estará alterando dados da pessoa relacionada.</Alert>
                    <Text fontSize="small" children="Dados pessoais:" />

                    <Form.Text
                        required
                        label="Nome completo:"
                        name="name"
                        defaultValue={consultant?.customer?.name}
                        value={form?.name}
                        error={errors?.name}
                        onChange={onChange}
                        size="lg"
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Data de Nascimento:"
                        name="dob"
                        defaultValue={Moment(consultant?.customer?.dob).format('DD/MM/YYYY')}
                        value={form?.dob}
                        error={errors?.dob}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Divider />
                    <Text fontSize="small" children="Localização e contatos" />

                    <Form.Text
                        required
                        label="Endereço de e-mail:"
                        type="email"
                        name="email"
                        defaultValue={consultant?.customer?.email}
                        value={form?.email}
                        error={errors?.email}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Celular:"
                        type="tel"
                        name="mobile"
                        defaultValue={consultant?.customer?.mobile}
                        value={form?.mobile}
                        error={errors?.mobile}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Form.Loc onChangeCity={city_id => setForm({ city_id })} defaultValue={{ country: consultant?.customer?.city?.country_id, state: consultant?.customer?.city?.state_id, city: consultant?.customer?.city?.id }} isDisabled={loading} />

                    <Form.Text
                        required
                        label="Endereço (Linha 1):"
                        name="line_1"
                        value={form?.line_1}
                        defaultValue={consultant?.customer?.addresses[0]?.line_1}
                        error={errors?.line_1}
                        onChange={onChange}
                        placeholder="Ex.: Av. Brasil Sul"
                        disabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        label="Endereço (Linha 2):"
                        name="line_2"
                        value={form?.line_2}
                        defaultValue={consultant?.customer?.addresses[0]?.line_2}
                        error={errors?.line_2}
                        onChange={onChange}
                        disabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        required
                        label="CEP:"
                        name="zip"
                        value={form?.zip}
                        defaultValue={Mask.zip(consultant?.customer?.addresses[0]?.zip)}
                        error={errors?.zip}
                        onChange={onChange}
                        placeholder="Ex.: 74 023 010"
                        disabled={loading}
                        size="sm"
                        helper="O código postal do seu endereço."
                    />

                    <Form.Text
                        required
                        label="Bairro/Setor:"
                        name="neighborhood"
                        value={form?.neighborhood}
                        defaultValue={consultant?.customer?.addresses[0]?.neighborhood}
                        error={errors?.neighborhood}
                        onChange={onChange}
                        placeholder="Ex.: Setor Central"
                        disabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        label="Número:"
                        name="number"
                        value={form?.number}
                        defaultValue={consultant?.customer?.addresses[0]?.number}
                        error={errors?.number}
                        onChange={onChange}
                        placeholder="Ex.: 860"
                        disabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        label="Complemento:"
                        name="complement"
                        value={form?.complement}
                        defaultValue={consultant?.customer?.addresses[0]?.complement}
                        error={errors?.complement}
                        onChange={onChange}
                        placeholder="Ex.: 860"
                        disabled={loading}
                        size="sm"
                    />

                    <Divider />
                    <Text fontSize="small" children="Identidade:" />

                    <Alert status="warning" children="A identidade do usuário ainda não foi confirmada. Você pode ver os documentos enviados na sessão 'arquivos'." />

                    <Form.Text
                        required
                        label="CPF:"
                        name="doc_cpf"
                        defaultValue={Mask.cpf(consultant?.customer?.doc_cpf)}
                        value={form?.doc_cpf}
                        error={errors?.doc_cpf}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Form.Text
                        label="Registro Geral (RG):"
                        name="doc_rg"
                        defaultValue={consultant?.customer?.doc_rg}
                        value={form?.doc_rg}
                        error={errors?.doc_rg}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                </Form.Form>

            </DrawerBody>
            <DrawerFooter>
                <ButtonGroup isDisabled={loading}>
                    <Button children="Atualizar dados" isLoading={loading} onClick={auth.onOpen} />
                    <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                </ButtonGroup>
            </DrawerFooter>
        </Drawer>

        <Authenticate onSuccess={handleSubmit} {...auth} />
    </>
    )
}
